import { server, toastr } from '@/services/'

const state = {
  isFetching: false,
  items: [],
  serviceModules: []
}

const mutations = {
  setIsFetching (state, payload) {
    state.isFetching = payload
  },
  setItems (state, payload) {
    state.items = payload
  },
  setServiceModules (state, payload) {
    state.serviceModules = payload
  }
}

const getters = {
  getUserService: (state) => (code) => {
    return state.items.find(userService => userService.CODE === code)
  },
  getUserServiceName: (state) => (code) => {
    let service = state.items.find(userService => userService.CODE === code)
    if (!service) {
      return ''
    } else {
      return service.NAME
    }
  },
  getServiceModules: (state) => {
    let arr = []
    state.items.forEach((service) => {
      const obj = {
        serviceName: service.NAME
      }
      const tmp = service.MODULE.map((module) => {
        return {
          serviceCode: service.CODE,
          moduleName: module
        }
      })
      obj.module = tmp
      arr = [...arr, ...[obj]]
    })
    return arr
  }
}

const actions = {

  getAll ({ commit }) {
    return new Promise((resolve, reject) => {
      server.get('/getUserServices').then(
        resp => {
          const items = resp.data.msgContent.data
          commit('setItems', items)
          resolve(true)
        },
        err => {
          return reject(err.response)
        }
      )
    })
  },
  upsertItem({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      server.post('/upsertUserServices', payload.reqBody).then(
        resp => {
          if (payload.mode === 'Add') {
            toastr.addSuccess()
          } else {
            toastr.updateSuccess()
          }
          dispatch('getAll')
          resolve(true)
        },
        err => {
          toastr.serverError()
          reject(err.response)
        }
      )
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
